import styled from 'styled-components';

interface IIConProps {
  $imageURI?: string;
}

// Usado sobre o navy (sidebar e menu mobile)
export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  min-width: 0;
`;

export const Icon = styled.div<IIConProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cores.primarySoft};
  border: 2px solid ${({ theme }) => theme.cores.accent};
  color: ${({ theme }) => theme.cores.inkInverse};

  ${({ $imageURI }) => $imageURI ? `
    background-image: url(${$imageURI});
    background-size: cover;
  ` : ''}
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Usuario = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.cores.inkInverseMuted};
  font-size: ${({ theme }) => theme.fonte.caption};
`;

export const LoginUsuario = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.cores.inkInverse};
  font-weight: 600;
`;
